import { useDocumentDetails } from 'hooks/useDocumentDetails';
import type { Document } from 'types';
import type { DevelopmentPermit } from 'types/Documents';

export const useDevelopmentPermit = (id: string | null) => {
  return useDocumentDetails<Document<DevelopmentPermit> | null>(id);
};
